import { FC, useEffect, useState } from "react";
import ObjectTabsLayout from "components/common/objects/ObjectTabsLayout/ObjectTabsLayout";
import { useAppSelector } from "hooks";
import { selectDrawerSelectedAccountId } from "app/data/selectors";
import { useNavigate } from "react-router-dom";
import ObjectMaintenanceAlertsSection from "components/sections/objects/ObjectMaintenanceAlertsSection/ObjectMaintenanceAlertsSection";

const ObjectMaintenanceAlerts: FC = () => {
  const navigate = useNavigate();
  const drawerSelectedAccountId =
    useAppSelector(selectDrawerSelectedAccountId) || "";
  const [selectAccountId, setSelectedAccountId] = useState(
    drawerSelectedAccountId
  );

  useEffect(() => {
    if (drawerSelectedAccountId !== selectAccountId) {
      setSelectedAccountId(drawerSelectedAccountId);
      navigate("/dashboard/objects");
    }
  }, [drawerSelectedAccountId, selectAccountId, navigate]);

  return (
    <main>
      <ObjectTabsLayout>
        <ObjectMaintenanceAlertsSection />
      </ObjectTabsLayout>
    </main>
  );
};

export default ObjectMaintenanceAlerts;
